import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=2c55e936&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style0 from "./setting.vue?vue&type=style&index=0&id=2c55e936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c55e936",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c55e936')) {
      api.createRecord('2c55e936', component.options)
    } else {
      api.reload('2c55e936', component.options)
    }
    module.hot.accept("./setting.vue?vue&type=template&id=2c55e936&scoped=true&", function () {
      api.rerender('2c55e936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/open3d/setting.vue"
export default component.exports